<div class="flex justify-between">
  <div class="flex flex-col gap-1 py-2">
    <div class="text-xl leading-none font-semibold tracking-tight">Supprimer mon compte</div>
    <div class="text-gray-11">Cette action est définitive</div>
  </div>
  <button class="link destructive" (click)="deleteAccount.emit()" mat-button>
    <span> Supprimer </span>
  </button>
</div>
<mat-divider class="my-4"></mat-divider>
